export const INIT_MERGED_VALUES = 'INIT_MERGED_VALUES';

export function initMergedValues(mergedValues){
    return{
        type: INIT_MERGED_VALUES,
        mainState: {
            mergedValues: mergedValues
        }
    }
}